import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useState, useEffect } from 'react';
import EcoSpace from 'eco-design/base/eco-space';

export default function TheComp() {
    const { t } = useLang('dp3.page_v2');
    const [video, setVideo] = useState<[string, string]>(['', '']);
    const [enter, setEnter] = useState<boolean>(false);
    const [textEnter, setTextEnter] = useState<boolean>(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setEnter(true);
                    }
                });
            });
            observer.observe(document.getElementById('dp3-K1')!);

            const scene = AniContainer.create({
                triggerElement: '#dp3-K5 .box',
                triggerHook: 1,
                offset: 0,
                duration: '100%',
                onEnter: () => setTextEnter(true),
                onLeave: () => setTextEnter(false),
            });

            return () => scene.destroy();
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined' && enter) {
            setVideo(['https://websiteoss.ecoflow.com/upload/video/1745474917977/k5.mp4', 'https://websiteoss.ecoflow.com/upload/image/1745474917839/k5.jpg']);
        }
    }, [enter]);

    return (
        <section className={styles.section} id="dp3-K5">
            <EcoSpace />
            <div className={`info${textEnter ? ' enter' : ''}`}>
                <p className="info-title">{t('K5_title')}</p>
                <p className="info-desc">{t('K5_desc')}</p>
            </div>
            <div className="box">
                <div className="box-left">
                    {video[0] && video[1] && (
                        <video
                            className="box-left-video"
                            src={video[0]}
                            poster={video[1]}
                            autoPlay
                            loop
                            muted
                            playsInline
                            preload="auto"
                            width="100%"
                            height="100%"
                        />
                    )}
                </div>
                <div className="box-right">
                    <svg className="box-right-svg" xmlns="http://www.w3.org/2000/svg" width="42" height="47" viewBox="0 0 42 47" fill="none">
                        <path
                            d="M19.948 33.9425C25.1671 33.9425 29.3981 29.6688 29.3981 24.397C29.3981 19.1252 25.1671 14.8516 19.948 14.8516C14.729 14.8516 10.498 19.1252 10.498 24.397C10.498 29.6688 14.729 33.9425 19.948 33.9425Z"
                            fill="#D8D8D8"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M9.40756 38.2884C8.51377 37.7173 7.66627 37.0789 6.87769 36.3801C2.97821 32.9022 0.835317 28.2719 0.835539 23.3349C0.835539 18.403 2.97843 13.7759 6.86949 10.3059C12.1891 5.56459 20.3136 2.52948 31.0182 1.28382L42 0.00585938L32.5927 8.39024C33.4865 8.96114 34.3337 9.59969 35.1225 10.2985C39.0123 13.7679 41.1503 18.3965 41.1503 23.3392C41.1503 28.2819 39.0125 32.9107 35.1309 36.3727C29.8107 41.1142 21.6861 44.1496 10.9814 45.395L0 46.6725L9.40756 38.2884Z"
                            fill="white"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M20.9962 16.977C17.5173 16.977 14.6962 19.8248 14.6962 23.3406C14.6962 26.8565 17.5173 29.7043 20.9962 29.7043C24.4752 29.7043 27.2962 26.8565 27.2962 23.3406C27.2962 19.8248 24.4752 16.977 20.9962 16.977ZM29.3219 8.49219L25.2246 12.1437C27.1318 12.7077 28.8875 13.6792 30.3646 14.988C35.5368 19.6012 35.5368 27.0801 30.3646 31.6933C26.5472 35.0954 20.6472 37.2607 12.6678 38.1892L16.7652 34.5375C14.8579 33.9735 13.1023 33.0022 11.6251 31.6933C6.45293 27.0801 6.422 19.6285 11.6251 14.988C15.4425 11.5858 21.3425 9.42063 29.3219 8.49219Z"
                            fill="#566CFF"
                        />
                    </svg>
                    <p className="box-right-title">{t('K5_inner_title')}</p>
                    <p className="box-right-desc">{t('K5_inner_desc')}</p>
                </div>
            </div>
        </section>
    );
}
